// import { vfApp } from '@/utils/create-app'

import { addContainerWidgetSchema, addCustomWidgetSchema } from '@/components/form-designer/widget-panel/widgetsConfig';
import * as PERegister from '@/components/form-designer/setting-panel/propertyRegister';
import * as PEFactory from '@/components/form-designer/setting-panel/property-editor-factory.jsx';

import { collapseSchema, collapseItemSchema } from '@/extension/samples/extension-schema';
import CollapseWidget from '@/extension/samples/collapse/collapse-widget';
import CollapseItem from '@/extension/samples/collapse/collapse-item';
import CollapseAccordionPropertyEditor from '@/extension/samples/collapse/property-editor/collapse-accordion-editor';

import { alertSchema } from '@/extension/samples/extension-schema';
import AlertWidget from '@/extension/samples/alert/alert-widget';

export const loadExtension = function (app) {
  /**
   * 加载容器组件步骤：
   * 1. 加载组件Json Schema;
   * 2. 全局注册容器组件，容器组件有两种状态——设计期和运行期，故需要注册两个组件；
   * 3. 全局注册属性编辑器组件（基本属性、高级属性、事件属性）；
   * 4. 注册容器组件的代码生成器；
   * 5. 加载完毕。
   */
  addContainerWidgetSchema(collapseSchema); //加载组件Json Schema
  addContainerWidgetSchema(collapseItemSchema); //加载组件Json Schema
  /* -------------------------------------------------- */
  app.component(CollapseWidget.name, CollapseWidget); // 注册设计期的容器组件
  app.component(CollapseItem.name, CollapseItem); // 注册运行期的容器组件
  /* -------------------------------------------------- */

  PERegister.registerCPEditor(app, 'collapse-accordion', 'collapse-accordion-editor', CollapseAccordionPropertyEditor);

  PERegister.registerCPEditor(app, 'collapse-border', 'collapse-border-editor', PEFactory.createBooleanEditor('border', 'extension.setting.collapseBorder'));
  /* -------------------------------------------------- */
  /* 容器组件加载完毕 end */

  /**
   * 加载字段组件步骤：
   * 1. 加载组件Json Schema;
   * 2. 全局注册字段组件，字段组件设计期和运行期共用，故仅需注册一个组件；
   * 3. 全局注册属性编辑器组件（基本属性、高级属性、事件属性）；
   * 4. 注册字段组件的代码生成器；
   * 5. 加载完毕。
   */
  addCustomWidgetSchema(alertSchema); // 加载组件Json Schema
  /* -------------------------------------------------- */
  app.component(AlertWidget.name, AlertWidget); // 注册组件
  /* -------------------------------------------------- */
  PERegister.registerCPEditor(app, 'alert-title', 'alert-title-editor', PEFactory.createInputTextEditor('title', 'extension.setting.alertTitle'));

  let typeOptions = [
    { label: 'success', value: 'success' },
    { label: 'warning', value: 'warning' },
    { label: 'info', value: 'info' },
    { label: 'error', value: 'error' },
  ];

  PERegister.registerCPEditor(app, 'alert-type', 'alert-type-editor', PEFactory.createSelectEditor('type', 'extension.setting.alertType', { optionItems: typeOptions }));

  PERegister.registerCPEditor(app, 'alert-closable', 'alert-closable-editor', PEFactory.createBooleanEditor('closable', 'extension.setting.closable'));

  PERegister.registerCPEditor(app, 'alert-showIcon', 'alert-showIcon-editor', PEFactory.createBooleanEditor('showIcon', 'extension.setting.showIcon'));

  PERegister.registerEPEditor(app, 'alert-onClose', 'alert-onClose-editor', PEFactory.createEventHandlerEditor('onClose', []));
  /* -------------------------------------------------- */
  /* 字段组件加载完毕 end */
};
